<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Let's build something together!</h2>
                        <p class="lead text-white">I have the tools, you have the ideas. Let's put them together and make something great!</p>
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">
                    <div class="col-lg-4">
                        <icon name="fa fa-envelope" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Contact</h5>
                        <p class="text-white mt-3">From ideas to release. It all starts with your ideas and challenges. I offer you a free quote & proposal</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-code" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Development</h5>
                        <p class="text-white mt-3">I go through a vigerous process to ensure the software is made at the highest quality at every step</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-rocket" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Launch time</h5>
                        <p class="text-white mt-3">At this stage, the product is in full swing either inside the business or at your customer's screens</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <transition name="form-fade" mode="out-in">
                                <component v-bind:is="view" v-on:success="transitionOver"></component>
                            </transition>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ContactForm from './ContactForm.vue';
import ContactSuccess from './ContactSuccess.vue';

export default {
    mounted() {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', "https://www.google.com/recaptcha/api.js?render=6LfNqlQhAAAAAOlniHKxMWqEloaEf0grYErrF8-7");
        document.head.appendChild(recaptchaScript);
    },
    data() {
        return {
            view: ContactForm
        }
    },
    methods: {
        transitionOver() {
            this.view = ContactSuccess;
        }
    },
    components: {
        ContactForm,
        ContactSuccess
    }
}
</script>

<style>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>